import Autoclick from './autoclick/Autoclick';
import Time from './time/Time';

export default class Cheats extends Phaser.GameObjects.Container {
    private autoclick!: Autoclick;
    private time!: Time;

    constructor(scene: Phaser.Scene) {
        super(scene, 0, 0);

        this.setupAutoclick();
        this.setupTime();
    }

    setupAutoclick() {
        let x = 50;
        let y = this.scene.cameras.main.height - 362;

        this.autoclick = new Autoclick(this.scene, x, y);
        this.add(this.autoclick);
    }

    setupTime() {
        let x = 130;
        let y = this.scene.cameras.main.height - 362;

        this.time = new Time(this.scene, x, y);
        this.add(this.time);
    }
}
